import { AppBar, Grid, Toolbar, Box, Button, Divider, IconButton } from "@mui/material";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import { NavLink } from "react-router-dom";
export default function MobileUpBar({
    backLinkParams = { label: '', link: '/mobile/objects' },
    middleElement,
    linkVisible = true,
    style
}) {
    return (
        <Box sx={{ flexGrow: 1 }} {...style}>
            <AppBar position="static" color='backgrounds' elevation={0}>
                <Toolbar>
                    <Grid container>
                        <Grid item xs={2} container>
                            {linkVisible && (
                                <Button LinkComponent={NavLink} to={backLinkParams.link} variant='outlined' startIcon={<ArrowBackOutlinedIcon />}>
                                    {backLinkParams.label}
                                </Button>
                            )}

                        </Grid>
                        <Grid item xs={8} container>
                            <Box style={{ display: 'flex' }} sx={{ flexGrow: 1, justifyContent: 'center' }}>
                                {middleElement}
                            </Box>
                        </Grid>
                        <Grid item xs={2} container>
                            <Box style={{width:'100%', display:'flex', justifyContent:'end'}}>
                                <IconButton component={NavLink} to='/profile/details'>
                                    <PermIdentityIcon />
                                </IconButton>
                            </Box>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
            <Divider orientation='horizontal' />
        </Box>
    )
}